import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Company, SubNationalDivision } from 'src/app/classes/models';
import { StateFull } from 'src/app/interfaces/state-full';
import { CompanyService } from 'src/app/services/company.service';
import { SubNationalDivisionService } from 'src/app/services/sub-national-division.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-select-clients-modal',
  templateUrl: './select-clients-modal.component.html',
  styleUrl: './select-clients-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectClientsModalComponent implements OnInit {
  constructor(
    private Modal: NgbActiveModal,
    private CompanyService: CompanyService,
    private SubNationalDivisionService: SubNationalDivisionService,
    private UtilityService: UtilityService
  ) {}

  Companies?: Company[];
  CompaniesMap: Map<string, any> = new Map();
  SelectedCompaniesMap: Map<string, any> = new Map();

  SelectStates: boolean = false;
  SubNationalDivisionsMap: Map<string, any> = new Map();
  SelectedSubNationalDivisionsMap: Map<string, any> = new Map();

  submit() {
    const selectedCompanies: Company[] = [];
    const selectedStates: SubNationalDivision[] = [];

    this.SelectedCompaniesMap.forEach((id, legalName) => {
      const company = new Company({
        id,
        legalName
      });

      selectedCompanies.push(company);
    });

    this.SelectedSubNationalDivisionsMap.forEach((id, name) => {
      const subNationalDivision = new SubNationalDivision({
        id,
        name: name as StateFull
      });

      selectedStates.push(subNationalDivision);
    });

    this.Modal.close({ selectedCompanies, selectedStates });
  }

  close() {
    this.Modal.dismiss();
  }

  companyMapChange(selectedItems: Map<string, any>) {
    this.SelectedCompaniesMap = selectedItems;
  }

  subNationalDivisionMapChange(selectedItems: Map<string, any>) {
    this.SelectedSubNationalDivisionsMap = selectedItems;
  }

  ngOnInit(): void {
    this.SubNationalDivisionService.getSubNationalDivisions().subscribe({
      next: (SubNationalDivisions: SubNationalDivision[]) => {
        SubNationalDivisions.forEach((snd) => {
          const { id, name } = snd;

          if (id && name) {
            this.SubNationalDivisionsMap.set(name, id);
          }
        });
      }
    });

    this.CompanyService.getCompanies(
      this.UtilityService.stringifyObjectsInQueryObject({
        attributes: ['id', 'legalName'],
        status: { $notIn: ['unactivated', 'deactivated'] },
        order: [['legalName', 'ASC']]
      })
    ).subscribe({
      next: (companies) => {
        companies.forEach((company) => {
          const { legalName, id } = company;

          if (legalName && id) {
            this.CompaniesMap.set(legalName, id);
          }
        });
      }
    });
  }
}
